// Shared category-color mapping for the landing page's card sections
// (coach, subscription, event/booking) -- keeps CoachCard, SubscriptionCard,
// EventCard, and SessionByLocation's card all reading the same accent for
// the same category instead of each guessing independently. Keyed to the
// real top-level Coachify taxonomy (see coachifyCategoriesFallback.js's
// group ids: sports/health-wellness/gaming/hobbies/other) -- accepts either
// that slug form (SessionType.mainCategory) or the human display name
// ("Sports", "Health/Wellness", ...) since callers pull from both shapes
// depending on what data they already have on hand.
const CATEGORY_ACCENT_VARS = {
  sports: '--cfy-cat-sports',
  'health-wellness': '--cfy-cat-health-wellness',
  gaming: '--cfy-cat-gaming',
  hobbies: '--cfy-cat-hobbies',
  other: '--cfy-cat-other',
};

const DISPLAY_NAME_TO_SLUG = {
  sports: 'sports',
  'health/wellness': 'health-wellness',
  'health-wellness': 'health-wellness',
  gaming: 'gaming',
  hobbies: 'hobbies',
  other: 'other',
};

export const categoryToAccentVar = (categoryLike) => {
  const normalized = categoryLike ? String(categoryLike).trim().toLowerCase() : '';
  const slug = DISPLAY_NAME_TO_SLUG[normalized] || normalized;
  const varName = CATEGORY_ACCENT_VARS[slug] || CATEGORY_ACCENT_VARS.other;
  return `var(${varName})`;
};
